module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "associations-list"
  }, [_c('div', {
    staticClass: "share-button"
  }, [_c('button', {
    class: _vm.$i18n.locale() == 'ar' ? 'btn btn-success btn-xs pull-left' : 'btn btn-success btn-xs pull-right',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$store.commit('setShowShare', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Share')))])]), _vm._v(" "), _c('h1', {
    staticClass: "page-top-title"
  }, [_vm._v(_vm._s(_vm.$t('Charities')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model:value",
      value: (_vm.search),
      expression: "search",
      arg: "value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "search-asso",
      "placeholder": _vm.$t('Search by name or description')
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }, _vm.searchAsso]
    }
  }), _vm._v(" "), _vm._l((_vm.$store.getters.getCurrentAssoList), function(assoc) {
    return _c('div', {
      staticClass: "association-box",
      on: {
        "click": function($event) {
          _vm.selectAssociation(assoc.id)
        }
      }
    }, [_c('img', {
      staticClass: "assoc-logo",
      attrs: {
        "src": assoc.logo_url,
        "alt": _vm.$t(assoc.short_description)
      }
    }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(assoc.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(assoc.description))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t(assoc.country)))])])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f31cbca8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Associations.vue
// module id = 324
// module chunks = 1